import {z} from '@hono/zod-openapi';

import {err, ok, Result} from 'neverthrow';

type CredentialsInvalidError = {
  code: 'credentials-invalid';
  message: string;
  raw: z.ZodError;
};

type CredentialsSchema<T> = {
  safeParse: (data: unknown) => z.SafeParseReturnType<unknown, T>;
};

export function parseAdapterCredentials<T>(params: {
  credentials: unknown;
  schema: CredentialsSchema<T>;
  platformName: string;
}): Result<T, CredentialsInvalidError> {
  const result = params.schema.safeParse(params.credentials);
  if (!result.success) {
    return err({
      code: 'credentials-invalid',
      message: `Invalid ${params.platformName} credentials`,
      raw: result.error,
    });
  }

  return ok(result.data);
}
